import { useState } from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { suppliersCol } from "../../../../firebase.config";
import { addDoc } from "firebase/firestore";
import { Supplier } from "../../../interfaces";

export const SupplierForm = () => {
  const [supplier, setSupplier] = useState<string>("");

  const handleSaveClick = async (e: any) => {
    if (!supplier.length) return;

    const newSupplierObject: Omit<Supplier, "id"> = {
      name: supplier,
    };

    try {
      await addDoc(suppliersCol, newSupplierObject);
    } catch (error) {
      console.error("Error during saving supplier to firestore: ", error);
      return;
    }

    setSupplier("");
  };

  return (
    <Box
      sx={{
        paddingTop: "2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.5rem",
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: "1.5rem" }}>
        Dodaj dobavljača
      </Typography>
      <TextField
        id="outlined-basic"
        label="Ime dobavljača"
        variant="outlined"
        value={supplier}
        sx={{ width: "100%", maxWidth: "600px" }}
        onChange={(e) => setSupplier(e.target.value)}
      />
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#F1B317",
          color: "#595959",
          "&:hover": {
            backgroundColor: "#F1B317",
            color: "white",
          },
        }}
        onClick={handleSaveClick}
        disabled={!supplier.length}
      >
        Spremi
      </Button>
    </Box>
  );
};
